import {
  allPass,
  compose,
  defaultTo,
  filter,
  find,
  head,
  isEmpty,
  propEq,
  propOr,
  split,
  unless
} from 'ramda';

const getValues = (code, guarantees) =>
  compose(propOr([], 'values'), find(propEq('code', code)), defaultTo([]))(guarantees);

export const getValue = (code, guarantees) =>
  compose(defaultTo(''), head)(getValues(code, guarantees));

export const getPropForCode = (prop, code) => (guarantees) =>
  compose(
    propOr(null, prop),
    head,
    filter(allPass([propEq('parentCode', code), propEq('values', getValues(code, guarantees))])),
    defaultTo([])
  )(guarantees);

export const getIsSelected = (code, guarantees) =>
  compose(
    propOr(false, 'isSelected'),
    defaultTo({}),
    find(propEq('code', code)),
    defaultTo([])
  )(guarantees);

export const formatLegendAndLabel = (key, code, data) =>
  compose(unless(isEmpty, split(';')), defaultTo(''), getPropForCode(key, code))(data);
